import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { CounterService } from '../../../shared/service/data/counter.service';
import { DiscardModalModel } from '../../models/discard-modal.model';
import { SwProcessStateService } from './sw-process-state.service';

@Injectable({
  providedIn: 'root'
})
export class SwProcessPageUiService {
  private isSwDiscardModalActiveSubject: BehaviorSubject<DiscardModalModel> = new BehaviorSubject<DiscardModalModel>({
    isActive: false,
    isMainDiscard: false
  });
  public isSwDiscardModalActive$: Observable<DiscardModalModel> = this.isSwDiscardModalActiveSubject.asObservable();

  constructor(
    private swProcessStateService: SwProcessStateService,
    private counterService: CounterService
  ) {}

  public openSwDiscardModal(discardModal: DiscardModalModel): void {
    this.isSwDiscardModalActiveSubject.next(discardModal);
  }

  public closeSwDiscardModal(discardModal: DiscardModalModel): void {
    this.isSwDiscardModalActiveSubject.next(discardModal);
  }
}
